import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

const BUTTON_MOTION = {
  initial: { scale: 0 },
  animate: { scale: 1 },
  transition: { delay: 1, type: "spring", stiffness: 200 },
};

export default function WhatsAppButton() {
  const openWhatsApp = () => {
    const message = encodeURIComponent(
      "Hello, I am interested in Hybrid Coconut Seedlings from Kishan Coconut Nursery. Please provide more information."
    );
    window.open(`https://wa.me/919825911774?text=${message}`, "_blank");
  };

  return (
    <motion.button
      {...BUTTON_MOTION}
      onClick={openWhatsApp}
      className="fixed bottom-6 right-6 z-50 w-16 h-16 bg-[#25D366] hover:bg-[#20BD5A] rounded-full flex items-center justify-center shadow-lg whatsapp-btn transition-colors"
      data-testid="whatsapp-float-btn"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle className="w-8 h-8 text-white" />
    </motion.button>
  );
}
